import BigExclamationIcon from 'assets/icons/BigExclamationIcon'
import BodyText from 'components/UI/body-text/body-text'
import { Button } from 'components/UI/button/button'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { errorSelector } from 'redux/store/slices/error-slice'
import { PURGE } from 'redux-persist'
import tw from 'twin.macro'
import { pathnames } from 'utils/steps'

const ClientErrorPage = ({ resetErrorBoundary }: { resetErrorBoundary?: () => void }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const error = useSelector(errorSelector)

  const goToMainPage = () => {
    if (error.code === 'ACTIVATION_CANCELED') {
      resetErrorBoundary?.()
      dispatch({ type: PURGE, result: () => null })
      navigate('/activation-enter-phone')
    } else {
      resetErrorBoundary?.()
      dispatch({ type: PURGE, result: () => null })
      window.open(import.meta.env.NR_HOMEPAGE)
    }
  }

  const { t } = useTranslation('badcases')

  const returnErrorMessage = () => {
    switch (error.code) {
      case 'LANDING_NOT_AVAILABLE':
      case 'FETCH_ERROR':
        return t('common_error')
      default:
        return error.description || t('generic_error')
    }
  }
  return (
    <div tw='max-w-[800px] bg-secondary flex flex-col items-center mx-auto rounded-s30 p-10 flex flex-col gap-5'>
      <div tw='w-[144px] h-[144px] flex items-center justify-center rounded-full mx-auto bg-yellow-alpha20 mt-[48px]'>
        <BigExclamationIcon />
      </div>
      <BodyText twStyle={tw`text-center`}>{returnErrorMessage()}</BodyText>
      <Button variant='secondary' onClick={goToMainPage} twStyle={tw` max-w-[300px]`}>
        {t('cardLimit.close', { ns: 'badcases' })}
      </Button>
    </div>
  )
}
export default ClientErrorPage
